import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { ControlledField } from 'remote/global';
import {
  useDeleteOperatorsBankAccountMutation,
  usePostOperatorsBankAccountMutation,
} from 'api/queries/operators';
import { AccountBankDetailsSchemaType, accountBankDetailsSchema } from './types';
import PaperLayout from '../../PaperLayout';

function AccountBankDetailsForm({
  defaultValues,
}: {
  defaultValues?: AccountBankDetailsSchemaType;
}) {
  const tInstance = useTranslation();
  const { t } = tInstance;
  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isValidating, isLoading },
  } = useForm<AccountBankDetailsSchemaType>({
    defaultValues: {
      iban: '',
      ...defaultValues,
    },
    resolver: zodResolver(accountBankDetailsSchema),
  });
  const postOperatorsBankAccountMutation = usePostOperatorsBankAccountMutation();
  const deleteOperatorsBankAccountMutation = useDeleteOperatorsBankAccountMutation();

  const onValid = async (data: AccountBankDetailsSchemaType) => {
    try {
      // This implementation is a little bit different from regular forms as here we want to call DELETE when the IBAN field is empty
      if (data.iban.length === 0) await deleteOperatorsBankAccountMutation.mutateAsync();
      else await postOperatorsBankAccountMutation.mutateAsync(data);
    } catch (err) {
      // TODO: Capture sentry error
    }
  };

  return (
    <PaperLayout title={t('SettingsView.company.bankaccount.title')}>
      <form onSubmit={handleSubmit(onValid)}>
        <ControlledField control={control} name='iban' />
        <Button
          sx={{ marginTop: '24px' }}
          fullWidth
          type='submit'
          variant='contained'
          color='primary'
          disableElevation
          disabled={isSubmitting || isValidating || isLoading}
        >
          {t('save')}
        </Button>
      </form>
    </PaperLayout>
  );
}

export default AccountBankDetailsForm;
